import { createReducer, on } from '@ngrx/store';
import { IOdbBillAggregatorResponse } from 'src/app/my-bill/models/aggregator.model';
import {
  getBillingAggregatorFailure,
  getBillingAggregatorRequest,
  getBillingAggregatorSuccess,
} from '../actions/billing-aggregator.actions';

export interface BillingAggregatorState {
  billAggregatorResponse: IOdbBillAggregatorResponse | null;
  hasError: boolean;
  isFetching: boolean;
}

export const initialState: BillingAggregatorState = {
  billAggregatorResponse: null,
  hasError: false,
  isFetching: false,
};

export const billingAggregatorReducer = createReducer(
  initialState,
  on(getBillingAggregatorRequest, (state) => ({
    ...state,
    billAggregatorResponse: null,
    isFetching: true,
    hasError: false,
  })),
  on(getBillingAggregatorSuccess, (state, { billAggregatorResponse }) => ({
    ...state,
    billAggregatorResponse,
    isFetching: false,
    hasError: false,
  })),
  on(getBillingAggregatorFailure, (state) => ({
    ...state,
    billAggregatorResponse: null,
    isFetching: false,
    hasError: true,
  }))
);
